import React, { FC } from 'react'
import { joinClassNames } from 'utils'

interface RowProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {}

const Row: FC<RowProps> = ({ className, ...props }) => <div {...props} className={joinClassNames('flex items-center', className)} />

export default Row
